var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Intents List")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying Analytics Of Top Intents In Table")])]), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "dateRangePickerContainerTable"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _c('date-range-picker', {
    ref: "ref",
    staticClass: "ml-2 dateRangePicker",
    attrs: {
      "options": _vm.options
    }
  }), _c('i', {
    staticClass: "fa fa-caret-down"
  })], 1), _c('div', {
    staticClass: "pull-right ml-1 hidden-sm-down"
  }, [_c('b-dropdown', {
    staticClass: "float-right",
    attrs: {
      "variant": "transparent p-0"
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('img', {
    staticStyle: {
      "width": "14px",
      "height": "14px"
    },
    attrs: {
      "src": "static/img/download.png",
      "alt": ""
    }
  })]), _c('b-dropdown-item-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.clickDownloadxlsx
    }
  }, [_vm._v("Download as xlsx")]), _c('b-dropdown-item-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.clickDownloadpdf
    }
  }, [_vm._v("Download as pdf")])], 2)], 1)])]), _c('br'), _c('app-conversationtopictable', {
    attrs: {
      "data": _vm.totalTableItems,
      "label": _vm.totalTableFields
    }
  }), _c('br'), _c('app-conversationtopictable', {
    attrs: {
      "data": _vm.tableItems,
      "label": _vm.tableFields
    }
  })], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-518e7f51","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Analytics/IntentsList.vue
// module id = 1333
// module chunks = 1